import React, { useContext } from "react";
import { theme } from "../theme";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import { General } from "../tools/styles";
import Generic from "../components/Generic";
import RenderIf from "../components/RenderIf"
import Method from "../components/Method";
import FloatCard from "../components/ui/FloatCard";
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import calcSedConcern from "../tools/calcSedConcern";
import calcSedComplete from "../tools/calcSedComplete";

const BioSed = () => {
  
  const { biosed, setBiosed } = useContext(WatchContext)
  
  const handleChange = ({ target }) => {

    let unitsMessage = 'please enter units'
    let qualMessage = 'n/a'
    
    let data = handleInputChange(biosed, target)
    
    // need to give units a value so that van post method can appear as complete
    if (target.value === 'van post (qual)'){
      data = {...data, units: qualMessage}
    } else if ((data.units === unitsMessage || data.units === 'n/a') && data.method !== 'van post (qual)'){
      data = {...data, units: ''}
    }
    
    let concernedData = calcSedConcern(data)
  
    let completeData = calcSedComplete(concernedData)
  
    setBiosed(completeData)
  };

  let methods = biosed.methods.map(method => method.method)

  // biosed.currentConcern = 0
  // console.log(biosed.currentConcern === true)

  return (
   <>
      <General.Heading color={theme.colors.pdeBlue}>
        {biosed.title}
      </General.Heading>
     
      <Generic
     text={biosed.metric}
     title='Metric'
     />
       <Method
        currentValue={biosed.method}
        methodArray={methods}
        handleChange={handleChange}
      />
      <RenderIf isTrue={biosed.method === 'van post (qual)'}>
      <General.BlockContainer>
    <General.Block>
      <FloatCard width="300px">
        <General.InputCont>
          <General.Input
          className='input'
            type="number"
            name="currentValue"
            value={biosed.currentValue}
            onChange={handleChange}
            placeholder=" "
            required
          />
          <General.Label className='placeholder'>Current Value</General.Label>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
          <span >
            Justification
          </span>
        </General.InputCont>
        <General.InputCont margin='0 1rem'>
          <General.Text
          className='input'
            name="currentJust"
            value={biosed.currentJust}
            onChange={handleChange}
            placeholder=' '
            required
          ></General.Text>
          <General.Label className='placeholder'>Measurement source?</General.Label>
        </General.InputCont>
        
        <General.InputCont>
          <p>You can drag the lower right corner to make more room.</p>
        </General.InputCont>
      </FloatCard>
    </General.Block>
    <General.Block color={theme.colors.grey4}>
      <h2>Current or Most Recent</h2>
    </General.Block>
  </General.BlockContainer>
      </RenderIf>
      <RenderIf isTrue={biosed.method !== 'van post (qual)'}>
      <Current
        currentValue={biosed.currentValue}
        units={biosed.units}
        just={biosed.currentJust}
        handleChange={handleChange}
      />
      </RenderIf>
      <Criteria
        low={biosed.criteriaLow}
        high={biosed.criteriaHigh}
        units={biosed.units}
        type={biosed.criteriaType}
        just={biosed.criteriaJust}
        handleChange={handleChange}
      />
     <Generic
     align='center'
     title='Concerns'
     text={ <>
     <General.InputCont>
     <RenderIf isTrue={biosed.currentConcern === 1}>
     <General.BoldPara>
         {biosed.metric} currently falls outside the healthy range of values.
       </General.BoldPara>
   </RenderIf>
   <RenderIf isTrue={biosed.currentConcern === 0}>
     
       <p>
         {biosed.metric} currently falls within the healthy range of values.
       </p>
     
   </RenderIf>
   <RenderIf isTrue={biosed.currentConcern === -1}>
     
       <p>
         Need more information.
       </p>
     
   </RenderIf>
     </General.InputCont>
   
   
   </>}
     />
      
      </>
  );
};

export default BioSed;
